import { useLayoutEffect, useRef, useState } from "react";

export default function useBoardViewport() {
  const boardRef = useRef(null);
  const [size, setSize] = useState({ offset: 0, minimum: 520 });

  useLayoutEffect(() => {
    const board = boardRef.current;
    if (!board) return;
    let frame;
    let observedCards = new Set();
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(schedule) : null;
    function measure() {
      const bounds = board.getBoundingClientRect();
      let minimum = 520;
      const nextCards = new Set();
      board.querySelectorAll("[data-board-cards]").forEach(list => {
        const cards = Array.from(list.children).filter(child => child.classList.contains("MuiCard-root")).slice(0, 3);
        cards.forEach(card => nextCards.add(card));
        if (!cards.length) return;
        const heights = cards.map(card => card.getBoundingClientRect().height);
        const contentHeight = heights.length >= 3
          ? heights[0] + heights[1] + heights[2] / 2
          : Math.max(...heights) * 2.5;
        // Header + compact search + two card gaps + list padding + bottom scrollbar.
        minimum = Math.max(minimum, Math.ceil(list.getBoundingClientRect().top - bounds.top + contentHeight + 48));
      });
      observedCards.forEach(card => { if (!nextCards.has(card)) observer?.unobserve(card); });
      nextCards.forEach(card => { if (!observedCards.has(card)) observer?.observe(card); });
      observedCards = nextCards;
      const offset = Math.ceil(bounds.top + window.scrollY + 48);
      setSize(previous => previous.offset === offset && previous.minimum === minimum ? previous : { offset, minimum });
    }
    function schedule() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(measure);
    }
    measure();
    for (let parent = board.parentElement; parent; parent = parent.parentElement) observer?.observe(parent);
    const mutations = new MutationObserver(schedule);
    mutations.observe(board, { childList: true, subtree: true });
    window.addEventListener("resize", schedule);
    return () => {
      cancelAnimationFrame(frame);
      observer?.disconnect();
      mutations.disconnect();
      window.removeEventListener("resize", schedule);
    };
  }, []);

  return {
    boardRef,
    boardHeight: `max(${size.minimum}px, calc(100dvh - ${size.offset}px))`,
  };
}
